import { toast } from 'react-toastify';
import css from './request-email-modal.module.scss';
import { ReactComponent as CopyIcon } from 'src/assets/ContentCopy.svg';

export default function ViewCard({ text, title }: Readonly<{ text: string; title: string }>) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    toast.success('Скопійовано в буфер обміну');
  };

  return (
    <div className={css.viewCard}>
      <h4>{title}</h4>
      <p dangerouslySetInnerHTML={{ __html: text }}></p>
      <CopyIcon title='Скопіювати' onClick={copyToClipboard} />
    </div>
  );
}
